import { useMediaQuery } from "@mui/material";
import Layout from "../../components/Layout";
import PageTitle from "../../components/PageTitle";
import { TableSearch } from "../../components/Table/TableActions";
import useStyles from "./style";
import Modal from "../../components/Modal";
import Table from "../../components/Table/Table";
import { Icon } from "@iconify/react";
import { useEffect, useState } from "react";
import Button from "../../components/Button";
import SelectGroup from "../../components/FormComponent/SelectGroup";
import { httprequest } from "../../data/api";
import { toast } from "react-toastify";
import Badge from "../../components/Badge";
import PopModal from "../../components/PopupModal/PopModal";

const EmailSubscription = () => {
  const isMobile = useMediaQuery("(max-width:600px)");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [emailUnitBalance, setEmailUnitBalance] = useState(0);
  const [tableData, setTableData] = useState([]);
  const [selectedPackageId, setSelectedPackageId] = useState("");
  const classes = useStyles();
  const [packageOptions, setPackageOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const columns = [
    {
      name: "Package",
      selector: (row) => (
        <>
          {isMobile && <p className="mobile-styling">Package</p>}
          {row.email_package}
        </>
      )
    },
    {
      name: "Units",
      selector: (row) => (
        <>
          {isMobile && <p className="mobile-styling">Units</p>}
          {row.units}
        </>
      )
    },
    {
      name: "Amount",
      selector: (row) => (
        <>
          {isMobile && <p className="mobile-styling">Amount</p>}
          {row.amount}
        </>
      )
    },
    {
      name: "Type",
      center: true,
      cell: (row) => (
        <p style={{ display: "flex", flexDirection: "column" }}>
          {isMobile && <p style={{ margin: 0, fontSize: "12px" }}>Status</p>}
          <Badge status={row.status} />
        </p>
      )
    },
    {
      name: "Date",
      selector: (row) => (
        <>
          {isMobile && <p className="mobile-styling">Date</p>}
          {row.created_at?.substring(0, 10)}
        </>
      )
    },
    {
      name: "",
      center: true,
      sortable: false,
      selector: (row) => (
        <div key={row?.id} className="table-action-container">
          <button className="table-action-icon">
            <Icon icon="mi:print" />
          </button>
          <button className="table-action-icon">
            <div className="delete-icon"><Icon icon="mingcute:delete-2-line" /></div>
          </button>
        </div>
      )
    }
  ];

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  /**
   * @function handleBuyUnits
   * @description This function handles the purchase of email units.
   * @returns {void} - This function handles the purchase of email units.
   * It checks if a package is selected, makes an API call to get the payment URL,
   */

  const handleBuyUnits = () => {
    if (!selectedPackageId) {
      toast.error("Please select a package first");

      return;
    }
    setIsLoading(true);
    httprequest
      .get(`/api/v1/email-sub/payment/${selectedPackageId}`)
      .then((res) => {
        if (res.data.error === false && res.data.data.redirect_url) {
          toast.success(res.data.message);
          setSelectedPackageId("");
          window.location.href = res.data.data.redirect_url;
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((error) => {
        toast.error(error.response?.data?.message || "An error occurred");
        setSelectedPackageId("");
      })
      .finally(() => {
        toggleModal();
        setIsLoading(false);
      });
  };

  /**
   * @function fetchEmailUnitBalance
   * @description This function fetches the email unit balance from the API.
   * @returns {void} - This function fetches the email unit balance from the API and updates the state.
   * It does not return any value.
   */
  const fetchEmailUnitBalance = async () => {
    httprequest
      .get("/api/v1/email-sub/unit-balance")
      .then((res) => {
        setEmailUnitBalance(res.data.data);
      })
      .catch(() => {
      });
  };

  const fetchTableData = () => {
    httprequest
      .get("/api/v1/email-sub/overview")
      .then((res) => {
        setTableData(res.data.data.payment_history);
      })
      .catch(() => {
      });
  };

  const fetchPackageOptions = () => {
    httprequest
      .get("/api/v1/email-package")
      .then((res) => {
        setPackageOptions(res.data.data);
      })
      .catch(() => {
      });
  };

  /**
   * @function handlePackageChange
   * @description This function handles the change of the selected package from the dropdown.
   * @param {*} event - The event object from the change event of the select element.
   * @returns {void} - This function updates the selectedPackageId state with the value of the selected package.
   */
  const handlePackageChange = (event) => {
    const selectedId = event.target.value;
    setSelectedPackageId(selectedId);
  };
  useEffect(() => {
    fetchEmailUnitBalance();
    fetchTableData();
    fetchPackageOptions();
  }, []);

  return (
    <Layout children={
      <>
        <PageTitle
          title="Email Subscription"
          subtitle="You can manage your emails and subscription here."
          button={
            <PopModal title="Email Subscription" videoUrl="https://www.youtube.com/watch?v=FFY0Ny2hEBo&feature=youtu.be" />
          }
        />
        <div className={classes.card}>
          <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
            <span>Email Unit Balance</span>
            <h2>{emailUnitBalance}</h2>
          </div>
          <button onClick={toggleModal} className={classes.button}>
          Buy More Units
          </button>

        </div>
        <div className="page-content">
          <Table
            data={tableData}
            columns={columns}
            pagination
            subHeader={true}
            subHeaderComponent={
              <TableSearch
                placeholder="Search here..."
              />
            }
          />
        </div>

        <Modal
          title="Buy Email Units"
          subtitle="Enter the package you want to purchase."
          modalContent={
            <div className="input-padding">
              <SelectGroup label="Select a package" children={
                <select name="package" value={selectedPackageId} onChange={handlePackageChange}>
                  <option value="">--- Select ---</option>
                  {packageOptions?.map((gend, i) => {
                    return (
                      <option key={i} value={gend?.id}>{gend?.name} ( {gend?.currency}{gend?.amount} per {gend?.unit}units )</option>
                    );
                  })}
                </select>
              }
              />
            </div>
          }
          modalFooter={
            <>
              <Button variant="primary" buttonSize="full" color="btndefault" buttonName="Buy" isLoading={isLoading} onClick={handleBuyUnits} />

            </>
          }
          isopen={isModalOpen}
          closeModal={toggleModal}
        />
        {/* <ToastContainer /> */}
      </>
    }

    />
  );
};

export default EmailSubscription;
